// extracted by mini-css-extract-plugin
module.exports = {"highlight":"ProponentTutorialContainer_highlight__1cE9B"};